//#region src/medication-marketplace/utils/headline-pricing.ts
const SELF_PAY_OFFER_PRIORITY = [
	"Incentive",
	"CashAssistance",
	"PharmacyIncentive",
	"DiscountedCashPrice",
	"SelfPayPriceAtPharmacy",
	"Cash"
];
const INSURANCE_OFFER_PRIORITY = [
	"CopayAssistance",
	"NonCoveredBenefit",
	"InsuredPriceAtPharmacy",
	"Retail"
];
const GOVERNMENT_OFFER_PRIORITY = [
	"MedicareBridge",
	"MedicarePartD",
	"GovernmentPriceAtPharmacy"
];
const isSelfPayOfferType = (type) => SELF_PAY_OFFER_PRIORITY.includes(type);
const isInsuranceOfferType = (type) => INSURANCE_OFFER_PRIORITY.includes(type);
const isGovernmentOfferType = (type) => GOVERNMENT_OFFER_PRIORITY.includes(type);

//#endregion
export { GOVERNMENT_OFFER_PRIORITY, INSURANCE_OFFER_PRIORITY, SELF_PAY_OFFER_PRIORITY, isGovernmentOfferType, isInsuranceOfferType, isSelfPayOfferType };